<template>
    <div
        class="l-ss-c-dropdown"
        :class="dropdownClass"
        v-click-outside="closeDropdown">
        <span
            class="l-ss-c-dropdown-link"
            @click="toggleDropdown">
            <slot v-if="hasLinkSlot"></slot>

            <template v-else>
                <span>{{ label }}</span>
                <i v-html="iconArrowRight"></i>
            </template>
        </span>

        <transition name="fade">
            <div
                class="l-ss-c-dropdown-body"
                :class="dropdownBodyClass"
                v-if="isOpen">
                <slot name="dropdown"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    import { ref, computed } from '@/lib/vue-composition-api.js';
    import iconArrowRight from '@/core/assets/images/icons/arrow-right.svg';
    import clickOutside from '@/core/directives/clickOutside';
    import { nanoid } from 'nanoid';

    export default {
        directives: {
            clickOutside,
        },
        props: {
            placement: {
                type: String,
                default: 'center',
            },
            label: {
                type: String,
            },
            dropdownBodyClass: {
                default: '',
            },
        },
        setup(props, { slots }) {
            const isOpen = ref(false);

            const hasLinkSlot = computed(() => {
                return !!slots.default;
            });

            const dropdownIdClassName = `l-ss-c-dropdown-id-${nanoid()}`;

            const dropdownClass = computed(() => {
                const classes = {
                    'l-ss-c-dropdown-open': isOpen.value,
                    [dropdownIdClassName]: true,
                };

                if (props.placement !== 'center') {
                    classes[`l-ss-c-dropdown-placement-${props.placement}`] = true;
                }

                if (!hasLinkSlot.value) {
                    classes['l-ss-c-dropdown-with-default-link'] = true;
                }

                return classes;
            });

            const toggleDropdown = () => {
                isOpen.value = !isOpen.value;
            };

            const closeDropdown = () => {
                isOpen.value = false;
            };

            return {
                isOpen,
                toggleDropdown,
                closeDropdown,
                dropdownClass,
                hasLinkSlot,
                iconArrowRight,
            };
        },
    };
</script>

<style scoped>

</style>
